export function generateShortId(sessionId: string): string {
  // Simple hash function to convert session ID to 8 alphanumeric characters
  let hash = 0;
  for (let i = 0; i < sessionId.length; i++) {
    const char = sessionId.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32-bit integer
  }
  
  // Convert to base36 (0-9, a-z) and take first 8 characters
  const base36 = Math.abs(hash).toString(36);
  
  // If less than 8 characters, pad with random alphanumeric
  if (base36.length < 8) {
    const chars = '0123456789abcdefghijklmnopqrstuvwxyz';
    let padding = '';
    for (let i = base36.length; i < 8; i++) {
      padding += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return (base36 + padding).toUpperCase();
  }
  
  return base36.substring(0, 8).toUpperCase();
}